import {makeAutoObservable} from "mobx";

class OrgPatientListStore {
    patientList = [] //Здесь хранятся данные о платежах
    sorted = {} // Здесь хранятся сортированные по полям данные о платежах
    filterURL = ''
    showCount = 'limit=' + 20 + '&'
    actualPage = 1
    printModal = {
        show: false,
        resultId: '',
        patientId: ''
    }

    constructor() {
        makeAutoObservable(this)
    }

    setData(arr) {
        this.patientList = arr

    }

    //Метод переворачивает массив
    reverseByField(field) {
        this.patientList = this.sorted[field]
        this.patientList.reverse()
    }

    setFilterURL(filterData) {
        this.filterURL = ''
        this.filterURL = this.filterURL + filterData
    }

    setShowCount(count) {
        this.showCount = 'limit=' + count + '&'
    }

    setActualPage(pageNum) {
        this.actualPage = pageNum
    }

    showPrintModal(resultId, patientId) {
        this.setPrintData(resultId, patientId)
        this.printModal.show = !this.printModal.show
    }

    setPrintData(resultId, patientId) {
        this.printModal.resultId = resultId
        this.printModal.patientId = patientId

    }

    closeImageId() {
        this.printModal.show = false
        this.printModal.imageId = ''
    }
}

export default new OrgPatientListStore()
